import React, { Component } from "react";
import ReactPlayer from "react-player";
import "./style.css";

class VideoPopup extends Component {
  render() {
    if (this.props.show) {
      return (
        <div className={`videopopup`}>
          <button className="videopopup__close" onClick={this.props.onClose}>
            &#10005;
          </button>
          <div className="videopopup__text">{this.props.text}</div>
          <hr className="videopopup__hr"></hr>
          <div className="videopopup__player-wrapper">
            <ReactPlayer
              config={{
                youtube: {
                  playerVars: { showinfo: 1, controls: 1, autoplay: 0 },
                },
              }}
              // playing={this.props.show}
              className="videopop__video"
              width="100%"
              height="100%"
              url={this.props.url}
            />
            {/* <ReactPlayer
            config={{
              youtube: {
                playerVars: { showinfo: 1, controls: 1 },
              },
            }}
            playing={this.props.show}
            className="videopop__video"
            width="100%"
            height="100%"
            url={this.props.url}
          /> */}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

VideoPopup.defaultProps = {
  show: false,
  url: "",
  onClose: () => {},
  text: "",
};

export default VideoPopup;



// WEBPACK FOOTER //
// ./src/components/videopopup/index.js